import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

import {Locales, LocaleTranslations} from '@constants/locales.constants';
import dayjs from '@utils/dayjs.utils';
import env from '@config/env.config';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import {i18nextPlugin} from 'translation-check';

const formatTranslation = (value, format?: string, locale?: string) => {
  if (value instanceof Date && locale && format) {
    return dayjs(value).locale(locale).format(format);
  }

  if (typeof value === 'string' && format === 'uppercase') {
    return value.toUpperCase();
  }

  if (typeof value === 'string' && format === 'lowercase') {
    return value.toLowerCase();
  }

  return value;
};

if (env.USE_LOCAL_TRANSLATION === 'true') {
  i18n
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
      fallbackLng: Locales.FR,
      debug: true,
      resources: LocaleTranslations,
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
        format: formatTranslation,
      },
    });
} else {
  i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .use(i18nextPlugin)
    .init({
      backend: {
        loadPath: `${env.AZURE_STORAGE_URL}/translations/admin/{{lng}}.json`,
      },
      fallbackLng: Locales.FR,
      debug: true,
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
        format: formatTranslation,
      },
    });
}

export const getCurrentLanguage = (): string =>
  i18n.language?.split(/[-_]/)[0] ||
  window.localStorage.i18nextLng?.toString()?.split(/[-_]/)[0] ||
  '';

export default i18n;
